<mat-card *ngIf="logs">
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        Logs
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item class="log-item" *ngFor="let log of logs" (click)="openLog(log.name)">
          <mat-icon mat-list-icon>insert_drive_file</mat-icon>
          <h4 mat-line>{{log.name}}</h4>
          <p mat-line>Erstellt: {{log.stats.birthtime | date:'short'}} | Aktualisiert: {{log.stats.atime | date:'short'}}</p>
        </mat-list-item>
      </mat-list>
    </mat-card-content>

  </mat-expansion-panel>
</mat-card>

<mat-card *ngIf="singleLog">
  <div class="log-container">
    <pre>{{singleLog}}</pre>
  </div>

</mat-card>
